export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix - Thumbnail.557211b8.png";